import {RaikoCustomSimpleChip} from "../raikoCustomSimpleChip/RaikoCustomSimpleChip";
import {RaikoChipTypes} from "../RaikoChipTypes";
import PropTypes from "prop-types";

export default function RaikoCustomSimpleActiveDeActiveChip(
    {
        state,
        activeStateTitle,
        deActiveStateTitle
    }) {
    return (
        state && state === true ?
            <RaikoCustomSimpleChip title={activeStateTitle} type={RaikoChipTypes.success}/> :
            <RaikoCustomSimpleChip title={deActiveStateTitle} type={RaikoChipTypes.error}/>
    )
}

RaikoCustomSimpleActiveDeActiveChip.propTypes = {
    state: PropTypes.bool.isRequired,
    activeStateTitle: PropTypes.string.isRequired,
    deActiveStateTitle: PropTypes.string.isRequired
}